import React from "react"
import type { Locale } from "@skyltmax/locales"

export interface SignWebLocaleContextType {
  signWebLocale: Locale
  setSignWebLocale: (locale: Locale) => void
}

export const SignWebLocaleContext = React.createContext<SignWebLocaleContextType>({
  signWebLocale: "en-IE",
  setSignWebLocale: () => {},
})

export const useSignWebLocaleContext = () => React.useContext(SignWebLocaleContext)
